
import RegionHeader from "@/components/region/RegionHeader"
import RegionToolbar from "@/components/layout/navigation/RegionToolbar"
import SearchResultList from "@/components/search/SearchResultList"

import regionMeta from "@/mixins/regionMeta"
import currentYearMixin from "@/mixins/currentYearMixin"
import regionSearchRouting from "@/models/regionSearchRouting"

export default {
    meta: {
        toolbar: {
            hideSearch: true,
        },
        footer: {
            showPowered: true,
        },
    },
    watchQuery: true,
    components: { RegionToolbar, RegionHeader, SearchResultList },
    mixins: [currentYearMixin, regionMeta],
    async asyncData({ store, route, redirect, $axios }) {
        if (route.params.slug === "altmuehlfranken") {
            redirect("/region/altmuehlfranken")
            return
        }
        let categories = regionSearchRouting.getRouting(route)
        const response = await $axios.$get("/api/regions/" + route.params.slug)
        const region = response.data
        await store.dispatch("search/init", {
            categories: categories,
            selectedCategory: "Neuigkeiten",
            locationSlug: route.params.slug,
            channel: region.channel.slug,
            query: route.query,
            type: "region",
        })
        return {
            region: region,
        }
    },
    data: () => {
        return {
            region: {},
        }
    },
    head() {
        return {
            title: this.region.name + ": Betriebe geben Berufseinblicke",
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content:
                        this.region.name +
                        ": Tauche in den Berufsalltag der Unternehmen ein und bleib über alle Praktika und Ausbildungen auf dem Laufenden.",
                },
                {
                    hid: "og:title",
                    name: "og:title",
                    content:
                        this.region.name + ": Betriebe geben Berufseinblicke",
                },
                {
                    hid: "og:description",
                    name: "og:description",
                    content:
                        this.region.name +
                        ": Tauche in den Berufsalltag der Unternehmen ein und bleib über alle Praktika und Ausbildungen auf dem Laufenden.",
                },
                ...this.getOgImage(),
            ],
        }
    },
}
